export default __webpack_public_path__ + "static/media/goggles.ceabc751.png";